import React, { useCallback } from 'react';
import { useStoreContext } from '../../../../store/context';
import '../stations/Station.scss';
import { 
  DailyTablePopUp,
  HourlyTablePopUp,
  NfdrHourlyTablePopUp,
} from '.';
import { NfdrDailyTable } from './nfdrTables/NfdrDailyTable';

type TablePopUpProps = {
  id: any;
  stationMeta?:any;
};
export const TablePopUp: React.FC<TablePopUpProps> = ({
  id, stationMeta
}) => {
  const [state] = useStoreContext();

  const PopUpType = useCallback(()=>{
        if(state.mapDataType==='Weather' && state.selectedRadio.type ==='hourly'){
          return(
            <HourlyTablePopUp id={id} stationMeta={stationMeta}/>
          );
        }
        else if(state.mapDataType==='Weather' && state.selectedRadio.type ==='daily'){
          return(
            <DailyTablePopUp id={id} stationMeta={stationMeta}/>
          )
        }
        else if(state.mapDataType==='FireDanger' && state.selectedRadio.type ==='hourly'){
          return(
            <NfdrHourlyTablePopUp id={id} stationMeta={stationMeta}/>
          )
        }
        else if(state.mapDataType==='FireDanger' && state.selectedRadio.type ==='daily'){
          return(
            <NfdrDailyTable id={id} stationMeta={stationMeta}/>
          )
        }
        else{
          return;
        }
    
    },[
       id, stationMeta, state.mapDataType, state.selectedRadio.type
  ]);
  return (
    <div>
      {PopUpType()}
    </div>
  );
}
